// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/css/fontawesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/css/all.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/css/swipper.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/css/main.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto+Slab:wght@300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isotop-item {
  height: fit-content !important;
}

@media (max-width: 991px) {
  .main_menu_2 {
    display: none !important;
  }
}

.projectsGrid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;
  grid-gap: 0;
  align-content: start;
}

.projectsGrid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;
  grid-auto-rows: minmax(100px, auto);
  grid-gap: 0;
  align-content: start;
}
.projectsGrid .isotop-item {
  overflow: hidden !important;
}

.bostami-parsonal-info-social-link {
  width: 230px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0px 7.5px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.handleHover:hover {
  color: var(--common-black) !important;
}

.sunicon {
  font-size: 20px;
  color: #fff;
}

.moonicon {
  font-size: 20px;
}

.mode-btn {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.mode-btn:hover {
  color: #fff;
}

.fadeup {
  animation: fadeup 0.5s linear 0s 1 backwards;
}

.fadeingpre > * {
  animation: fafein 1.5s linear 0s 1 backwards;
}

@keyframes fafein {
  0% {
    opacity: 0;
  }
  55% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeup {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    transform: translateY(0px);
  }
}
body .form-input-item input {
  color: var(--common-black);
}
body .form-input-item textarea {
  color: var(--common-black);
}
body.dark-theme .form-input-item input {
  color: #fff;
}
body.dark-theme .form-input-item textarea {
  color: #fff;
}

body {
  background-position: center center;
  background-size: cover;
}

.modal-header {
  width: fit-content !important;
  z-index: 1100 !important;
}

.cursor-pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/custom.scss","webpack://./src/main.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;ACOF;;ADJE;EADF;IAEI,wBAAA;ECQF;AACF;;ADLA;EACE,wBAAA;EACA,sEAAA;EAEA,WAAA;EACA,oBAAA;ACOF;;ADLA;EACE,wBAAA;EACA,sEAAA;EACA,mCAAA;EACA,WAAA;EACA,oBAAA;ACQF;ADPE;EAEE,2BAAA;ACQJ;;ADLA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;ACQF;;ADLE;EACE,qCAAA;ACQJ;;ADLA;EACE,eAAA;EACA,WAAA;ACQF;;ADNA;EACE,eAAA;ACSF;;ADPA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;ACUF;ADTE;EACE,WAAA;ACWJ;;ADPA;EACE,4CAAA;ACUF;;ADNE;EACE,4CAAA;ACSJ;;ADLA;EACE;IACE,UAAA;ECQF;EDNA;IACE,UAAA;ECQF;EDNA;IACE,UAAA;ECQF;AACF;ADNA;EACE;IACE,UAAA;IACA,2BAAA;ECQF;EDLA;IACE,0BAAA;ECOF;AACF;ADFI;EACE,0BAAA;ACIN;ADFI;EACE,0BAAA;ACIN;ADCM;EACE,WAAA;ACCR;ADCM;EACE,WAAA;ACCR;;ADUA;EACE,kCAAA;EACA,sBAAA;ACPF;;ADSA;EACE,6BAAA;EACA,wBAAA;ACNF;;ADQA;EACE,eAAA;ACLF","sourcesContent":[".isotop-item {\n  height: fit-content !important;\n}\n.main_menu_2 {\n  @media (max-width: 991px) {\n    display: none !important;\n  }\n}\n\n.projectsGrid {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;\n  // grid-auto-rows: none !important;\n  grid-gap: 0;\n  align-content: start;\n}\n.projectsGrid {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)) !important;\n  grid-auto-rows: minmax(100px, auto);\n  grid-gap: 0;\n  align-content: start;\n  .isotop-item {\n    // max-height: fit-content;\n    overflow: hidden !important ;\n  }\n}\n.bostami-parsonal-info-social-link {\n  width: 230px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0px 7.5px;\n  margin: 0 auto;\n  margin-bottom: 30px;\n}\n.handleHover {\n  &:hover {\n    color: var(--common-black) !important ;\n  }\n}\n.sunicon {\n  font-size: 20px;\n  color: #fff;\n}\n.moonicon {\n  font-size: 20px;\n}\n.mode-btn {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  &:hover {\n    color: #fff;\n  }\n}\n\n.fadeup {\n  animation: fadeup 0.5s linear 0s 1 backwards;\n}\n\n.fadeingpre {\n  & > * {\n    animation: fafein 1.5s linear 0s 1 backwards;\n  }\n}\n\n@keyframes fafein {\n  0% {\n    opacity: 0;\n  }\n  55% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeup {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0px);\n  }\n}\n\nbody {\n  .form-input-item {\n    input {\n      color: var(--common-black);\n    }\n    textarea {\n      color: var(--common-black);\n    }\n  }\n  &.dark-theme {\n    .form-input-item {\n      input {\n        color: #fff;\n      }\n      textarea {\n        color: #fff;\n      }\n    }\n  }\n}\n// .btn-1{\n//     &:focus{\n//         color: #fff !important;\n//     }\n// }\n\nbody {\n  background-position: center center;\n  background-size: cover;\n}\n.modal-header {\n  width: fit-content !important;\n  z-index: 1100 !important;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n","\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto+Slab:wght@300;400;500;600;700;800;900&display=swap');\n\n@import \"./assets/css/bootstrap.min.css\";\n\n@import \"./assets/css/fontawesome.min.css\";\n@import \"./assets/css/all.min.css\";\n\n@import \"./assets/css/swipper.css\";\n@import \"./assets/css/main.css\";\n@import \"./custom.scss\";\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
